import { getAvatar } from 'conversations-internal-schema/responders/operators/responderGetters';
export const getLauncherAvatarSrcs = (sendFromResponders, companyLogo) => {
  const responderAvatarImageSrcs = sendFromResponders.toArray().map(responder => {
    var _getAvatar;
    return (_getAvatar = getAvatar(responder)) !== null && _getAvatar !== void 0 ? _getAvatar : '';
  });
  const avatarImageSrcs = responderAvatarImageSrcs.length > 0 ? responderAvatarImageSrcs : [companyLogo];
  return avatarImageSrcs;
};